import React, { useEffect } from "react";
import { doc, setDoc } from "firebase/firestore";
import { db } from "../firebaseConfig";
import { useNavigate } from "react-router-dom";

export default function SuccessPage({ user, setUser }) {
  const navigate = useNavigate();

  useEffect(() => {
    const saveSubscriberStatus = async () => {
      if (!user) return;

      try {
        await setDoc(doc(db, "users", user.uid), { isSubscriber: true }, { merge: true });
        setUser({ ...user, isSubscriber: true });
      } catch (error) {
        console.error("灯主ステータス保存失敗:", error);
      }
    };

    saveSubscriberStatus();
  }, [user, setUser]);

  return (
    <div style={styles.wrapper}>
      <h2 style={styles.title}>灯りがともりました</h2>
      <p style={styles.message}>
        あなたの灯りが、この世界に静かにともされました。  
        これからは、ことばの灯りを無制限にともすことができます。
      </p>
      <button onClick={() => navigate("/mypage")} style={styles.button}>
        灯りの置き場を見る
      </button>
    </div>
  );
}

const styles = {
  wrapper: { padding: "40px 20px", textAlign: "center", maxWidth: "600px", margin: "0 auto" },
  title: { fontSize: "24px", marginBottom: "20px" },
  message: { fontSize: "16px", lineHeight: "1.6", color: "#444", marginBottom: "30px" },
  button: { padding: "10px 20px", backgroundColor: "#e0f7fa", border: "none", borderRadius: "6px", cursor: "pointer" }
};
